import {CommentList as CommentListComponent, Item} from './CommentList'

export const CommentList = Object.assign(CommentListComponent, {Item})
